var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.25C6.17437 1.25149 4.90347 1.77875 3.96611 2.71611C3.02875 3.65347 2.50149 4.92437 2.5 6.25C2.5 8.28438 3.97688 9.97375 5.54125 11.7619C6.03625 12.3281 6.54875 12.9138 7.005 13.5063C7.06339 13.582 7.13837 13.6433 7.22419 13.6855C7.31001 13.7277 7.40437 13.7497 7.5 13.7497C7.59563 13.7497 7.68999 13.7277 7.77581 13.6855C7.86163 13.6433 7.93661 13.582 7.995 13.5063C8.45125 12.9138 8.96375 12.3281 9.45875 11.7619C11.0231 9.97375 12.5 8.28438 12.5 6.25C12.4985 4.92437 11.9712 3.65347 11.0339 2.71611C10.0965 1.77875 8.82563 1.25149 7.5 1.25ZM7.5 8.125C7.12916 8.125 6.76665 8.01503 6.45831 7.80901C6.14996 7.60298 5.90964 7.31014 5.76773 6.96753C5.62581 6.62492 5.58868 6.24792 5.66103 5.88421C5.73337 5.52049 5.91195 5.1864 6.17417 4.92417C6.4364 4.66195 6.77049 4.48338 7.13421 4.41103C7.49792 4.33868 7.87492 4.37581 8.21753 4.51773C8.56014 4.65964 8.85298 4.89996 9.05901 5.20831C9.26503 5.51665 9.375 5.87916 9.375 6.25C9.375 6.74728 9.17746 7.22419 8.82583 7.57583C8.47419 7.92746 7.99728 8.125 7.5 8.125Z",
    fill: "#AAA4C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.98ab3f7fcbbc2a6d2d998d5cb76abb64.svg";
export { ForwardRef as ReactComponent };